import store from '@/assets/common/store/state.js';

const actions = {
    setNowSystemTime ({commit}, val) {
        commit('setNowSystemTime', val)
    }
};

for (let key in store) {
    actions[`setter${key}`] = function ({
        commit,
        state
    }, value) {
        commit(`SET_${key.toUpperCase()}`, value)
    }
}

export default actions;